module.exports = __webpack_public_path__ + "static/media/zgroup-logo.75170181.svg";